<template>
  <div class="container">
    <h1>{{ titulo }}</h1>
    <form @submit.prevent="cadastrarBanner">
      <div class="modal-body">
        <div class="md-form">
          <i class="fas fa-user prefix grey-text"></i>
          <label data-error="wrong" data-success="right" for="textoCurto"
            >Texto Curto:</label
          >
          <ckeditor
            :editor="editor"
            v-model="payload.textoCurto"
            :config="editorConfig"
            id="fff"
            class="form-control validate"
          ></ckeditor>
        </div>
        <div class="md-form">
          <i class="fas fa-user prefix grey-text"></i>
          <label data-error="wrong" data-success="right" for="imagemPequena"
            >Imagem pequena:</label
          >
          <input
            type="file"
            id="imagemPequena"
            ref="imagemPequena"
            @change="processarImagemPequena($event)"
          />
        </div>

        <div class="md-form">
          <i class="fas fa-user prefix grey-text"></i>
          <label data-error="wrong" data-success="right" for="urllink"
            >URL Link:</label
          >
          <input
            type="text"
            id="urllink"
            class="form-control validate"
            v-model="payload.URLLink"
          />
        </div>

        <div class="md-form">
          <i class="fas fa-user prefix grey-text"></i>
          <label data-error="wrong" data-success="right" for="tituloBanner"
            >Título:</label
          >
          <input
            type="text"
            id="tituloBanner"
            class="form-control validate"
            v-model="payload.titulo"
          />
        </div>

        <div class="md-form">
          <i class="fas fa-user prefix grey-text"></i>
          <label data-error="wrong" data-success="right" for="leadBanner"
            >Lead:</label
          >
          <ckeditor
            :editor="editor"
            v-model="payload.lead"
            :config="editorConfig"
            id="fff"
            class="form-control validate"
          ></ckeditor>
        </div>

        <div class="md-form">
          <i class="fas fa-user prefix grey-text"></i>
          <label data-error="wrong" data-success="right" for="textoBanner"
            >Texto:</label
          >
          <ckeditor
            :editor="editor"
            v-model="payload.texto"
            :config="editorConfig"
            id="fff"
            class="form-control validate"
          >
            CKEDITOR.on( 'instanceReady', function( ev ) { var editor =
            ev.editor, dataProcessor = editor.dataProcessor, htmlFilter =
            dataProcessor && dataProcessor.htmlFilter; htmlFilter.addRules({ a :
            function ( element ){ element.attributes['target']="_blank"; } });
            });
          </ckeditor>
        </div>

        <div class="md-form">
          <i class="fas fa-user prefix grey-text"></i>
          <label data-error="wrong" data-success="right" for="imagemGrande"
            >Imagem grande:</label
          >
          <input
            type="file"
            id="imagemGrande"
            ref="imagemGrande"
            @change="processarImagemGrande($event)"
          />
        </div>

        <div>
          <label for="avisar" class="form-check-label">Avisar?</label>
          <select
            class="form-control"
            id="avisos-banner"
            v-model="payload.avisos"
          >
            <option
              v-for="aviso in tiposDeAvisos"
              v-bind:value="aviso.identifier"
              v-bind:key="aviso.identifier"
            >
              {{ aviso.value }}
            </option>
          </select>
        </div>

        <div class="md-form" style="margin-left: 1rem">
          <input
            type="checkbox"
            id="bannerRestito"
            class="form-check-input validate"
            v-model="payload.restrito"
          />
          <label for="bannerRestito" class="form-check-label">Restrito?</label>
        </div>
      </div>

      <div class="modal-footer d-flex justify-content-center">
        <button class="btn btn-unique" type="submit">
          {{ textoBotao }} <i class="fas fa-paper-plane-o ml-1"></i>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { bannerAPI } from "@/modules/home";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  computed: {
    ...mapGetters(["token"]),
    titulo() {
      if (this.payload.bannerId) {
        return "Atualiza Conteúdo Banner";
      }
      return "Cadastro Conteúdo Banner";
    },
    textoBotao() {
      if (this.payload.bannerId) {
        return "Atualizar";
      }
      return "Cadastrar";
    },
  },
  data() {
    return {
      editor: ClassicEditor,
      editorData: "<p>Digite aqui!</p>",
      editorConfig: {
        link: {
          addTargetToExternalLinks: true,
        },
      },
      tiposDeAvisos: [
        { identifier: 1, value: "Comprador" },
        { identifier: 2, value: "Produtor" },
        { identifier: 3, value: "Todos" },
        { identifier: 0, value: "Ninguém" },
      ],
    };
  },
  props: {
    payload: { type: Object, default: { avisos: 0 } },
  },
  methods: {
    ...mapActions(["setLoading"]),
    processarImagemPequena(event) {
      this.payload.imagemPequenaArray = event.target.files[0];
    },
    processarImagemGrande(event) {
      this.payload.imagemGrandeArray = event.target.files[0];
    },
    cadastrarBanner() {
      this.setLoading(true);
      const formData = new FormData();

      formData.append("avisos", this.payload.avisos);
      formData.append("textoCurto", this.payload.textoCurto);
      formData.append("uRLLink", this.payload.URLLink);
      formData.append("titulo", this.payload.titulo);
      formData.append("lead", this.payload.lead);
      formData.append("texto", this.payload.texto);
      formData.append("imagemPequenaArray", this.payload.imagemPequenaArray);
      formData.append("imagemGrandeArray", this.payload.imagemGrandeArray);

      if (this.payload.bannerId) {
        formData.append("bannerId", this.payload.bannerId);
      }

      const promisse = this.payload.bannerId
        ? bannerAPI.update(formData)
        : bannerAPI.create(formData);

      promisse
        .then((resp) => {
          this.setLoading(false);
          this.payload = {};
          this.$toast("Banner salvo com sucesso", {
            timeout: 2000,
            hideProgressBar: true,
          });
          window.location.reload();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$toast.error("Erro ao salvar banner", {
            timeout: 2000,
            hideProgressBar: true,
          });
        });
    },
  },
};
</script>
